export default __webpack_public_path__ + "static/media/pluskim.1c58ceb2.jpg";